export const gitVersion = 'docs-flow-1.0.13-502-g2dca3c89';
